import { useEffect, useState } from 'react'
import { Row, Col, Button, Modal, Pagination, Card, OverlayTrigger, Tooltip, Table, Spinner } from 'react-bootstrap'
import data from '../../lib/backend/data'
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import BoxList from './box-list';
import CargandoDetalleFull from './cargando_detalle_full';
import DetailFull from './detalle-full';
import { useDispatch, useSelector } from 'react-redux';
import { formatoMoneda } from '../../lib/helpers/main';
import { fechaATexto, fechaATextoSimple } from '../../lib/helpers/helpers';
import { cerrarSesion } from '../../redux/actions/session';
import SelectorTipoCostos from '../costos-tipos/selector';
import SelectorSubTipoCostos from '../costos-sub-tipo/selector';
import SelectorRangoFechas from '../general/selector_rango_fechas';
import { stringByTitleCost } from '../../lib/helpers/data/facturacion/main';
import GraficosCostos from './graficos';
import SelectorClientes from '../clientes/selector';
import HelperModal from '../general/helperModal';

const CostoListado = (props) => {
    const initialDate = {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    }
    const [ proveedores, setProveedores ] = useState([])
    const [ loadingProveedores, setLoadingProveedores ] = useState(true)
    const [ patente, setPatente ] = useState('')
    const [ numeroInterno, setNumeroInterno ] = useState('')
    const [ removiendo, setRemoviendo ] = useState(false)
    const [ openModal, setOpenModal ] = useState(false)
    const [ vehiculoSeleccionado, setVehiculoSeleccionado ] = useState(false)
    const [ loadingDetalle, setLoadingDetalle ] = useState(false)
    const [ idSeleccionado, setIdSeleccionado ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const [ total, setTotal ] = useState(0)
    const [ indicadores, setIndicadores ] = useState([])
    const [ filtroTipo, setFiltroTipo ] = useState('')
    const [ filtroSubTipo, setFiltroSubTipo ] = useState('')
    const [ filtroCliente, setFiltroCliente ] = useState('')
    const [ showModal, setShowModal ] = useState(false)
    const [ pagina, setPagina ] = useState(1)
    const [ condicion_busqueda, setCondicionBusqueda ] = useState(props.condicion_default ? props.condicion_default : {})
    const session = useSelector(state => state.miusuario)
    const token = session.tokenSession
    const trash = props.trash ? props.trash : false
    const [ selectionRange, setSelectionRange ] = useState(initialDate)
    const [ crearNuevo, setCrearNuevo ] = useState(true)
    const [ parametroBusqueda, setParametroBusqueda ] = useState('')
    
    const dispatch = useDispatch()

    const obtenerProveedores = async (page, query)=>{
        setLoadingProveedores(true)
        if(query) if(trash === true) query.status = 'trash'
        const condicion = query ? query : condicion_busqueda
        return fetch(`${data.urlapi}/costos/list`,{
            method:'POST',
            body: JSON.stringify({
                condicion,
                pagina: page
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            console.log(res)
            if(!res){
                toast.error('Sin datos')
                return setLoadingProveedores(false)
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
                return setLoadingProveedores(false)
            }
            if(Array.isArray(res.datos) !== false){
                setProveedores(res.datos)
                setTotal(res.total)
                if(res.indicadores) if(Array.isArray(res.indicadores) !== false) setIndicadores(res.indicadores)
            }
            return setLoadingProveedores(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoadingProveedores(false)
        })
    }
    
    const paginar = (page,ignorar) => {
        if(ignorar) return false
        setPagina(page)
        obtenerProveedores(page)
    }

    const handleClose = () => {
        setOpenModal(false)
        setShowModal(false)
    }

    const modalFiltro = () => {
        
        return <Modal show={openModal} size="lg" onHide={()=>handleClose()}
        centered
        >
        <Modal.Header closeButton>
          <Modal.Title>Filtrar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <Col xs={12} className="mb-2">
                    <label className='d-block form-control-label'>Fecha</label>
                    <select name="tipo_fecha" className='form-control'>
                        <option value="createdAt">Creación</option>
                        <option value="updatedAt">Actualización</option>
                        <option value="compromiso">Compromiso</option>
                        <option value="ruta">Fecha ruta</option>
                    </select>
                </Col>
                <Col md={12}>
                    <Button size="sm" variant="success">FILTRAR</Button>
                </Col>
            </Row>
        </Modal.Body>
        
      </Modal>
    }

    const paginacion = (ciclo, total) => {
        const cantidad = Math.ceil(total / ciclo)
        return <div>
            <Pagination size='sm'>
                {
                    Array.from(Array(cantidad).keys()).map(number => {
                        const active = pagina === (number+1) ? true : false
                        return <Pagination.Item key={number+1} active={active} onClick={()=>paginar(number+1,active)} >{number+1}</Pagination.Item>
                    })
                }
            </Pagination>
        </div>
    }

    useEffect(() => {
        obtenerProveedores(1, false)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const refrescarRegistros = () => {
        let condicion = {}
        if(filtroTipo) condicion.tipo = filtroTipo
        if(filtroCliente) condicion.cliente = filtroCliente
        if(filtroSubTipo) condicion.subtipo = filtroSubTipo
        setCondicionBusqueda(condicion)
        obtenerProveedores(1, condicion)
    }

    const cargandoScreen = () => {
        return <Row>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
            </Row>
    }

    const tabla_registros = (registros) => {
        if(loadingProveedores===true) return cargandoScreen()
        if(registros.length < 1) return  <div>
            <HelperModal tipo='facturacion' style='nodata'/>
        </div>
        return <div>
            <h5>{(registros.length * pagina) - registros.length + 1} - {registros.length * pagina} <b style={{ fontWeight:'lighter' }}>de {total}</b></h5>
            {paginacion(data.pagina, total)}
            <Table>
            <thead>
                <tr>
                    <th>Monto</th>
                    <th>Categoría</th>
                    <th>Sub categoría</th>
                    <th>Fecha</th>
                    <th>Eliminar</th>
                </tr>
            </thead>
            
            {
                        registros.map(orden => {
                            let seleccionado = false
                            if(idSeleccionado === orden._id) seleccionado = true
                            return <tr key={orden._id} className="mb-3">
                                    <td>{formatoMoneda(orden.tarifa)}</td>
                                    <td>{stringByTitleCost(orden.tipo)}</td>
                                    <td>{stringByTitleCost(orden.subtipo)}</td>
                                    <td>{fechaATextoSimple(orden.createdAt)}</td>
                                    <td><Button variant="outline-danger" style={{ fontSize:11 }} size="sm">ELIMINAR</Button></td>
                            </tr>
                        })
                    }
            </Table>
            {paginacion(data.pagina, total)}
        </div>
    }

    const handleSubmitPalabra = (e) => {
        e.preventDefault()
        if(!parametroBusqueda){
            const condicion = {}
            setCondicionBusqueda(condicion)
            setPagina(1)
            return obtenerProveedores(1, condicion)
        }
        const condicion = { nombre: parametroBusqueda }
        setCondicionBusqueda(condicion)
        setPagina(1)
        return obtenerProveedores(1, condicion)
    }
    const reiniciar = () => {
        setPagina(1)
        setCondicionBusqueda({})
        obtenerProveedores(1, {})
    }

    const onProveedorGuardado = (data) => {
        console.log(data)
        const i = proveedores.findIndex(a => a._id === data._id)
        if(i < 0) return false
        proveedores[i] = data
        return setProveedores(prev => [...[], ...proveedores])
    }

    const crearProveedor = () => {
        setLoadingDetalle(true)
            setIdSeleccionado(false)
            setVehiculoSeleccionado(false)
            setTimeout(() => {
                setLoadingDetalle(false)
            }, 100);
    }

    const handleChangePalabra = (e) => {
        const { value } = e.target
        return setParametroBusqueda(value)
    }

    const onProveedorNuevo = (data) => {
        proveedores.unshift(data)
        setProveedores(prev => [...[], ...proveedores])
        crearProveedor()
    }

    const onFieldDeleted = (id) => {
        const i = proveedores.findIndex(c => c._id === id)
        if(i < 0) return false
        proveedores.splice(i,1)
        setVehiculoSeleccionado(false)
        return setProveedores(prev => [...[], ...proveedores])
    }
 
    const mostrarCreacion = () => {
        return <Modal show={showModal} size="lg" onHide={handleClose} centered >
        <Modal.Header closeButton>
        <Modal.Title>Detalles del costo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {
                        loadingDetalle === true ? <CargandoDetalleFull /> : <DetailFull 
                        onFieldDeleted={(id) => onFieldDeleted(id)}
                        crear={crearNuevo} 
                        onProveedorNuevo={(data) => onProveedorNuevo(data)} 
                        token={token} 
                        proveedor={vehiculoSeleccionado} 
                        onProveedorGuardado={(data) => onProveedorGuardado(data)} 
                        />
        }
        </Modal.Body>
    </Modal>
    }

    const handleChangeTipo = (e) => {
        console.log(e)
        if(!e) return false
        return setFiltroTipo(e.value)
    }
    const handleChangeSubTipo = (e) => {
        console.log(e)
        if(!e) return false
        return setFiltroSubTipo(e.value)
    }
    const handleChangeCliente = (e) => {
        console.log(e)
        if(!e) return false
        return setFiltroCliente(e.rut)
    }

    const cambiarRangoFecha = (item) => {
        console.log(item.selection)
        return setSelectionRange(item.selection)
    }

    return <div>
        {modalFiltro()}
        {mostrarCreacion()}
        
        <Row>
            <Col md={12}>
            <h4 style={{fontWeight:700 }}>Costos <OverlayTrigger
                            placement={'top'}
                            overlay={
                              <Tooltip>Crear nueva</Tooltip>
                            }
                            >
                            <i className="fa-solid text-primary hover fa-circle-plus" onClick={()=>{
                                crearProveedor()
                                setShowModal(true)
                                }} ></i>
                          </OverlayTrigger>
              
              </h4>
                <Row>
                    {/* <Col md={12} className='mb-3'>
                        <form onSubmit={handleSubmitPalabra}>
                        <input className='mb-3 form-control' placeholder='BUSCAR POR PALABRAS CLAVE' onChange={handleChangePalabra} />
                        </form>
                    </Col> */}
                    <Col md={12} className='mb-3'>
                        <SelectorRangoFechas onChange={item => cambiarRangoFecha(item)} />
                    </Col >
                    <Col md={4}>
                    <SelectorTipoCostos titulo="Filtrar por categoría" onChange={handleChangeTipo} />
                    </Col>
                    <Col md={4}>
                    <SelectorSubTipoCostos titulo="Filtrar por sub categoría" onChange={handleChangeSubTipo} />
                    </Col>
                    <Col md={4}>
                    <SelectorClientes titulo="Filtrar por cliente" full_payload={true} onChange={handleChangeCliente} />
                    </Col>
                    <Col className='mb-3 pr-0 row justify-content-end'>
                        {/* <label className='form-control-label d-block'>Click para consultar</label> */}
                        {loading === true ? <Spinner animation='border' /> : <button className='btn btn-primary d-block' onClick={()=>refrescarRegistros()}><b>CONSULTAR</b></button>}
                    </Col>
                    <Col xs={12}>
                        <GraficosCostos condicion_default={condicion_busqueda} />
                    </Col>
                </Row>
                {tabla_registros(proveedores)}
            </Col>
            
        </Row>
    </div>

}

export default CostoListado